import { toast } from 'react-toastify';
/* eslint-disable import/no-cycle */
import Socket from './socket/Socket';
import Mediasoup from './mediasoup/Mediasoup';
import MediasoupCanProduceError from './mediasoup/MediasoupError';
import MediaError from './media/MediaError';
import { store } from '../store';
import getSearchParams from '../utils/searchParams/getSearchParams';
import localStorage from '../utils/localStorage';
import videoConferenceSuccessSocketRequest from './socket/successSocketRequest/successSocketRequest';
import videoConferenceFailureSocketRequest from './socket/failureSocketRequest/failureSocketRequest';
import videoConferenceSocketEvent from './socket/socketEvent/socketEvent';
import chatSuccessSocketRequestCallback from './socket/chat/success/Success';
import chatFailureSocketRequestCallback from './socket/chat/failure/Failure';
import chatSocketEventCallback from './socket/chat/event/Event';
import { mediaTypes } from '../constants/mediaTypes';
import MessageAdapter from '../utils/adapters/MessageApapter';
import Queue from './Queue';
import history from '../utils/history/history';
import navigation from '../constants/navigation';
import objectToSearchParams from '../utils/searchParams/objectToSearchParams';
import scalabilityLayers, { getLayersByLevel } from '../constants/scalabilityLayers';
import isMobileOS from '../constants/isMobileOS';
import { educationEventsApi } from '../api/apiEndpoints';

// eslint-disable-next-line import/no-mutable-exports
let lesson = null;
const availableLessonRoles = { student: 'student', teacher: 'teacher' };

const delay = (ms = 0) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

/**
 * @class Lesson
 * @property {Socket}  socket
 * @property {Mediasoup}  mediasoup
 */
class Lesson {
  constructor() {
    this.socket = null;
    this.mediasoup = null;
    this.queue = null;
    this.modalWindowsStore = null;
    this.buttonsStore = null;
    this.reactionStore = null;
    this.roleInLesson = {
      value: '',
      isTeacher: null,
      isStudent: null,
    };
    this.lessonHash = '';
    this.lessonId = '';
    this.lessonName = '';
    this.teacherName = '';
    this.educationStakeholder = '';
    this.roomInfo = null;
    this.peerInfo = null;
    this.peerRoles = new Map();
    this.isIndividualLesson = null;
    this.isAllClassMode = null;
    this.teacherPeerId = '';
    this.isLessonInformationExist = false;
    this.isLessonOnPause = false;
    this.isReadyToHandleEvents = false;
    this.isRelevant = true;
    this.messageAdapter = '';
    this._localMediaOperation = Promise.resolve();
    this._lastLocalMediaStartAt = 0;
    this.errors = {
      lessonHasBeenStartedError: 'LessonHasBeenStartedError',
      lessonHasNotBeenStartedError: 'LessonHasNotBeenStartedError',
      lessonHasBeenClosedError: 'LessonHasBeenClosedError',
      lessonAlreadyContainsUser: 'LessonAlreadyContainsUser',
      accessDeniedError: 'AccessDeniedError',
    };
    this.actions = {
      joinLesson: 'joinLesson',
      getLessonInfo: 'getLessonInfo',
      getRoomInfo: 'getRoomInfo',
      startLesson: 'startLesson',
      endLesson: 'endLesson',
      startBreakLesson: 'startBreakLesson',
      stopBreakLesson: 'stopBreakLesson',
    };
    this.chatActions = {
      getMessagesChat: 'getMessagesChat',
      sendMessageChat: 'sendMessageChat',
      deleteMessageChat: 'deleteMessageChat',
      readMessageChat: 'readMessageChat',
    };
    this.chatEvents = {
      newMessageChat: 'newMessageChat',
    };
    this.events = {
      lessonIsStarted: 'lessonIsStarted',
      lessonIsEnded: 'lessonIsEnded',
      lessonBreakStarted: 'lessonBreakStarted',
      lessonBreakStopped: 'lessonBreakStopped',
      userJoinedToLesson: 'userJoinedToLesson',
      userLeaveFromLesson: 'userLeaveFromLesson',
      deletedMessageChat: 'deletedMessageChat',
      gotNewMessageChat: 'newMessageChat',
      disconnect: 'disconnect',
    };
    this.videoConferenceActions = {
      getRtpCapabilities: 'getRtpCapabilities',
      startStreamByCamera: 'startStreamByCamera',
      startStreamByMicrophone: 'startStreamByMicrophone',
      startShareScreen: 'startShareScreen',
      stopStreamByCamera: 'stopStreamByCamera',
      stopStreamByMicrophone: 'stopStreamByMicrophone',
      stopShareScreen: 'stopShareScreen',
      startConsumeStream: 'startConsumeStream',
      stopConsumeStream: 'stopConsumeStream',
      setLayers: 'setLayers',
    };
    this.videoConferenceEvents = {
      userStartedStream: 'userStartedStream',
      userStoppedStream: 'userStoppedStream',
      userConsumerIsClosed: 'userConsumerIsClosed',
      consumerLayersChanged: 'consumerLayersChanged',
    };
    this.videoConferenceButtonsEvents = {};
    this.videoConferenceTeacherAction = {
      showThemeButtons: 'showThemeButtons',
      hideThemeButtons: 'hideThemeButtons',
      showThemeButtonsTo: 'showThemeButtonsTo',
      hideThemeButtonsTo: 'hideThemeButtonsTo',
      firstThemeButtonReaction: 'firstThemeButtonReaction',
      secondThemeButtonReaction: 'secondThemeButtonReaction',
      handUp: 'handUp',
      toiletNeed: 'toiletNeed',
      showYesNoButtons: 'showYesNoButtons',
      showYesNoButtonsTo: 'showYesNoButtonsTo',
      yesButtonReaction: 'yesButtonReaction',
      noButtonReaction: 'noButtonReaction',
      attentionNotification: 'attentionNotification',
      attentionNotificationTo: 'attentionNotificationTo',
      emojiNotification: 'emojiNotification',
      emojiNotificationTo: 'emojiNotificationTo',
      stopNotification: 'stopNotification',
      stopNotificationTo: 'stopNotificationTo',
      callNotification: 'callNotification',
      startStreamByCameraTo: 'startStreamByCameraTo',
      stopStreamByCameraTo: 'stopStreamByCameraTo',
      startStreamByMicrophoneTo: 'startStreamByMicrophoneTo',
      stopStreamByMicrophoneTo: 'stopStreamByMicrophoneTo',
    };
    this.videoConferenceTeacherEvent = {
      showedThemeButtons: 'showedThemeButtons',
      hiddenThemeButtons: 'hiddenThemeButtons',
      showedFirstThemeButtonReaction: 'showedFirstThemeButtonReaction',
      showedSecondThemeButtonReaction: 'showedSecondThemeButtonReaction',
      toiletNeeded: 'toiletNeeded',
      handUpped: 'handUpped',
      showedYesNoButtons: 'showedYesNoButtons',
      showedYesButtonReaction: 'showedYesButtonReaction',
      showedNoButtonReaction: 'showedNoButtonReaction',
      showedAttentionNotification: 'showedAttentionNotification',
      showedEmojiNotification: 'showedEmojiNotification',
      showedStopNotification: 'showedStopNotification',
      showedCallNotification: 'showedCallNotification',
      startStreamByCameraNotification: 'startStreamByCameraNotification',
      stopStreamByCameraNotification: 'stopStreamByCameraNotification',
      startStreamByMicrophoneNotification: 'startStreamByMicrophoneNotification',
      stopStreamByMicrophoneNotification: 'stopStreamByMicrophoneNotification',
    };
    this.oppositeEventNames = {
      [this.videoConferenceEvents.userStartedStream]: this.videoConferenceEvents.userStoppedStream,
      [this.events.userJoinedToLesson]: this.events.userLeaveFromLesson,
    };
    this.videoConferenceSuccessSocketRequest = videoConferenceSuccessSocketRequest.bind(this);
    this.videoConferenceFailureSocketRequest = videoConferenceFailureSocketRequest.bind(this);
    this.videoConferenceSocketEvent = videoConferenceSocketEvent.bind(this);

    this.chatSuccessSocketRequestCallback = chatSuccessSocketRequestCallback.bind(this);
    this.chatFailureSocketRequestCallback = chatFailureSocketRequestCallback.bind(this);
    this.chatSocketEventCallback = chatSocketEventCallback.bind(this);
    this._init();
    lesson = this;
  }

  async connect() {
    this.socket.setSuccessSocketRequestCallback(
      this.videoConferenceSuccessSocketRequest.name,
      this.videoConferenceSuccessSocketRequest,
    );
    this.socket.setFailureSocketRequestCallback(
      this.videoConferenceFailureSocketRequest.name,
      this.videoConferenceFailureSocketRequest,
    );
    this.socket.setSocketEventCallback(
      this.videoConferenceSocketEvent.name,
      this.videoConferenceSocketEvent,
    );

    this.socket.setSuccessSocketRequestCallback(
      this.chatSuccessSocketRequestCallback.name,
      this.chatSuccessSocketRequestCallback,
    );
    this.socket.setFailureSocketRequestCallback(
      this.chatFailureSocketRequestCallback.name,
      this.chatFailureSocketRequestCallback,
    );
    this.socket.setSocketEventCallback(
      this.chatSocketEventCallback.name,
      this.chatSocketEventCallback,
    );

    this.socket.setSuccessSocketReconnectCallback(this.connect.name, async () =>
      this._joinLesson(true),
    );
    this.socket.setSocketDisconnectCallback(this._removePeersInfo.name, () => {
      this._removePeersInfo();
    });

    try {
      await this.socket.connect(this.roleInLesson.isTeacher);

      const { data: info } = await this.socket.request(this.actions.getLessonInfo);

      if (!this.isRelevant) {
        return;
      }

      const IS_MENTOR = JSON.parse(window.localStorage.getItem('role'))?.includes('MENTOR');

      if (this.roleInLesson?.isStudent && !IS_MENTOR) {
        try {
          const startAtRaw =
            info?.payload?.startAt ??
            info?.payload?.start_at ??
            info?.payload?.start_datetime_utc ??
            info?.payload?.start_datetime ??
            null;
          const baseDate = startAtRaw ? new Date(startAtRaw) : new Date();
          const fromDate = startAtRaw
            ? Lesson._addDays(baseDate, -1)
            : Lesson._addDays(baseDate, -14);
          const toDate = startAtRaw ? Lesson._addDays(baseDate, 1) : Lesson._addDays(baseDate, 14);
          const response = await educationEventsApi.getStudentEducationEvents(fromDate, toDate);
          const events = response?.data?.data ?? response?.data ?? [];
          const match = Array.isArray(events)
            ? events.find(ev => {
                const url = ev?.lesson_url;
                return url?.includes(`lessonHash=${this.lessonHash}`);
              })
            : null;
          if (match?.lesson?.id) {
            this.lessonId = match.lesson.id;
            window.localStorage.setItem(
              'lessonEndData',
              JSON.stringify({ lessonId: this.lessonId }),
            );
          } else {
            console.warn('Lesson id NOT found via schedule', {
              lessonHash: this.lessonHash,
              fromDate,
              toDate,
              firstUrls: Array.isArray(events)
                ? events.slice(0, 10).map(e => e?.lesson?.lesson_url)
                : [],
            });
          }
        } catch (e) {
          console.error('Failed to resolve lessonId via schedule', e);
        }
      }

      if (this.isRelevant) {
        await this._joinLesson(false);
      }
    } catch (e) {
      console.error(e);
    }
  }

  async startLesson() {
    await this.socket.request(this.actions.startLesson);
  }

  async pauseLesson() {
    await this.socket.request(this.actions.startBreakLesson);
  }

  async resumeLesson() {
    await this.socket.request(this.actions.stopBreakLesson);
  }

  async stopLesson() {
    await this.socket.request(this.actions.endLesson);
  }

  exitFromLesson = (isDisconnectSocket = false) => {
    if (this) {
      if (isDisconnectSocket) {
        this.socket?.disconnect();
      }
      this.mediasoup?.stopMediaTransfer();
      this._clearData();
    }
  };

  getDefaultLocalMediaState() {
    return {
      lessonHash: this.lessonHash,
      isAudio: true,
      isVideo: true,
    };
  }

  getSavedLocalMediaState = () => localStorage.lessonLocalMediaState;

  isSavedLocalMediaStateRelevant() {
    const savedLocalMediaState = this.getSavedLocalMediaState();

    return savedLocalMediaState?.lessonHash === this.lessonHash;
  }

  getCurrentLocalMediaState() {
    if (this.isSavedLocalMediaStateRelevant()) {
      return {
        ...this.getDefaultLocalMediaState(),
        ...this.getSavedLocalMediaState(),
      };
    }

    const defaultLocalMediaState = this.getDefaultLocalMediaState();

    localStorage.lessonLocalMediaState = defaultLocalMediaState;

    return defaultLocalMediaState;
  }

  updateLocalMediaState(nextState) {
    const currentLocalMediaState = this.getCurrentLocalMediaState();

    localStorage.lessonLocalMediaState = {
      ...currentLocalMediaState,
      ...nextState,
      lessonHash: this.lessonHash,
    };
  }

  updateLocalAudioState(isAudio) {
    this.updateLocalMediaState({ isAudio });
  }

  updateLocalVideoState(isVideo) {
    this.updateLocalMediaState({ isVideo });
  }

  async applySavedLocalMediaState() {
    const { isAudio, isVideo } = this.getCurrentLocalMediaState();

    if (!isAudio) {
      await this.pauseLocalAudio();
    }

    if (!isVideo) {
      await this.mediasoup.softDisableLocalProducer(mediaTypes.videoType);
    }
  }

  async startLocalMedia(isShowErrorNotification = true, isKeepingPreviousState = false) {
    const promiseSettledArray = [
      this._startLocalAudio(isKeepingPreviousState),
      this._startLocalVideo(isKeepingPreviousState),
    ];

    if (!isMobileOS) {
      promiseSettledArray.push(this._startScreenShare());
    }

    await Promise.allSettled(promiseSettledArray).then(results => {
      let isSomeRejected = false;
      let isMediaAccessError = false;
      const mediasoupProduceErrors = [];
      const defaultErrorMessages = [];

      results.forEach(result => {
        const { status, reason } = result;

        if (status === 'rejected') {
          const { message } = reason;

          isSomeRejected = true;

          if (reason instanceof MediaError) {
            isMediaAccessError = true;
          } else if (reason instanceof MediasoupCanProduceError) {
            mediasoupProduceErrors.push(reason);
          } else {
            defaultErrorMessages.push(message);
          }
        }
      });

      if (isSomeRejected && isShowErrorNotification) {
        if (isMediaAccessError) {
          this.modalWindowsStore.openMediaAccessDenied(true);
        } else if (mediasoupProduceErrors.length) {
          mediasoupProduceErrors.forEach(mediasoupError => {
            const { message } = mediasoupError;

            toast.error(message);
          });
        } else {
          defaultErrorMessages.forEach(defaultErrorMessage => {
            toast.error(defaultErrorMessage);
          });
        }
      }
    });

    await this.applySavedLocalMediaState();
  }

  _startLocalAudio = async (isKeepingPreviousState = false) => {
    await this.mediasoup.produce(mediaTypes.audioType, isKeepingPreviousState);
  };

  _startLocalVideo = async (isKeepingPreviousState = false) => {
    await this.mediasoup.produce(mediaTypes.videoType, isKeepingPreviousState);
  };

  _startScreenShare = async () => {
    await this.mediasoup.produce(mediaTypes.screenType, true);
  };

  async pauseLocalAudio() {
    return this.runLocalMediaOperation('pauseLocalAudio', async () => {
      const { roomId } = this.roomInfo;
      const producerId = this.mediasoup.mediaStore.localMedia?.[mediaTypes.audioType]?.producerId;

      if (!producerId) {
        this.updateLocalAudioState(false);
        return;
      }

      await this.socket.request(this.videoConferenceActions.stopStreamByMicrophone, {
        roomId,
        producerId,
      });

      this.mediasoup.closeProducer(producerId);
      this.updateLocalAudioState(false);
    });
  }

  async pauseLocalVideo() {
    return this.runLocalMediaOperation('pauseLocalVideo', async () => {
      await this.mediasoup.softDisableLocalProducer(mediaTypes.videoType);
      this.updateLocalVideoState(false);
    });
  }

  async resumeLocalAudio() {
    return this.runLocalMediaOperation('resumeLocalAudio', async () => {
      try {
        await this.mediasoup.softEnableLocalProducer(mediaTypes.audioType);
        this.updateLocalAudioState(true);
      } catch (error) {
        const errorMessage = error?.message;

        if (error instanceof MediaError) {
          this.modalWindowsStore.openMediaAccessDenied(true);
        } else {
          toast.error(errorMessage);
        }

        throw error;
      }
    });
  }

  async resumeLocalVideo() {
    return this.runLocalMediaOperation('resumeLocalVideo', async () => {
      try {
        await this.mediasoup.softEnableLocalProducer(mediaTypes.videoType);
        this.updateLocalVideoState(true);
      } catch (error) {
        const errorMessage = error?.message;

        if (error instanceof MediaError) {
          this.modalWindowsStore.openMediaAccessDenied(true);
        } else {
          toast.error(errorMessage);
        }

        throw error;
      }
    });
  }

  runLocalMediaOperation(operationName, callback) {
    this._localMediaOperation = this._localMediaOperation
      .catch(error => {
        console.error('Previous local media operation failed', {
          operationName,
          error,
        });
      })
      .then(async () => {
        const now = Date.now();
        const diff = now - this._lastLocalMediaStartAt;
        const minDelayBetweenStarts = 350;

        if (this._lastLocalMediaStartAt && diff < minDelayBetweenStarts) {
          await delay(minDelayBetweenStarts - diff);
        }

        try {
          const result = await callback();
          this._lastLocalMediaStartAt = Date.now();
          return result;
        } catch (error) {
          console.error('Local media operation failed', {
            operationName,
            error,
          });
          throw error;
        }
      });

    return this._localMediaOperation;
  }

  enqueuePeerMediaTask(peerId, taskName, callback) {
    this.queue.pushTask(peerId, async () => {
      try {
        await callback();
      } catch (error) {
        console.error('Lesson peer media task failed', {
          peerId,
          taskName,
          error,
        });
      } finally {
        this.queue.resumeTaskExecuting(peerId);
      }
    });

    this.queue.startTask(peerId);
  }

  stopGettingMediaThreads(excludedPeerId, mediaType) {
    const { roomId } = this.roomInfo;
    const allRemoteMedias = this.mediasoup.getRemoteMedias();

    allRemoteMedias.forEach(remoteMedia => {
      const { peerId, isTeacherPeerType } = remoteMedia;

      if (peerId === excludedPeerId) {
        return;
      }

      this.enqueuePeerMediaTask(peerId, `stopGettingMediaThreads:${mediaType}`, async () => {
        await this.mediasoup.stopRemoteMediaLocally(roomId, peerId, mediaType, isTeacherPeerType);
      });
    });
  }

  resumeGettingMediaThreads(excludedPeerId, mediaType) {
    const { roomId } = this.roomInfo;
    const allRemoteMedias = this.mediasoup.getRemoteMedias();

    allRemoteMedias.forEach(remoteMedia => {
      const { peerId, isTeacherPeerType } = remoteMedia;

      if (peerId === excludedPeerId) {
        return;
      }

      const scalabilityLevel = this.isAllClassMode ? scalabilityLayers.low : scalabilityLayers.high;

      this.enqueuePeerMediaTask(peerId, `resumeGettingMediaThreads:${mediaType}`, async () => {
        await this.mediasoup.resumeRemoteMediaLocally(
          roomId,
          peerId,
          mediaType,
          isTeacherPeerType,
          scalabilityLevel,
        );
      });
    });
  }

  stopGettingCertainMediaThread(peerId, mediaType) {
    const { roomId } = this.roomInfo;
    const remoteMedia = this.mediasoup
      .getAllRemoteMedias()
      .find(remoteMediaItem => remoteMediaItem.peerId === peerId);

    if (!remoteMedia) {
      return;
    }

    const { isTeacherPeerType } = remoteMedia;

    this.enqueuePeerMediaTask(peerId, `stopGettingCertainMediaThread:${mediaType}`, async () => {
      await this.mediasoup.stopRemoteMediaLocally(roomId, peerId, mediaType, isTeacherPeerType);
    });
  }

  resumeGettingCertainMediaThread(peerId, mediaType) {
    const { roomId } = this.roomInfo;
    const remoteMedia = this.mediasoup
      .getAllRemoteMedias()
      .find(remoteMediaItem => remoteMediaItem.peerId === peerId);

    if (!remoteMedia) {
      return;
    }

    const { isTeacherPeerType } = remoteMedia;
    const scalabilityLevel = this.isAllClassMode ? scalabilityLayers.low : scalabilityLayers.high;

    this.enqueuePeerMediaTask(peerId, `resumeGettingCertainMediaThread:${mediaType}`, async () => {
      await this.mediasoup.resumeRemoteMediaLocally(
        roomId,
        peerId,
        mediaType,
        isTeacherPeerType,
        scalabilityLevel,
      );
    });
  }

  forcedStopGettingMediaThreads(mediaType) {
    const { isStudent } = this.roleInLesson;
    const excludedPeerId = isStudent ? this.teacherPeerId : null;
    this.mediasoup.setForcedBlockedMediaStreams(mediaType);
    this.mediasoup.setNewMediaBlockedStreams({ [mediaType]: true });
    this.stopGettingMediaThreads(excludedPeerId, mediaType);
  }

  forcedResumeGettingMediaThreads(mediaType) {
    this.mediasoup.removeForcedBlockedMediaStreams(mediaType);
    this.mediasoup.setNewMediaBlockedStreams({ [mediaType]: false });
    this.resumeGettingMediaThreads(null, mediaType);
  }

  setAllClassMode(allClassModeFlag, blockedMediaType, excludedPeerId) {
    this.isAllClassMode = allClassModeFlag;
    const forcedBlockedMediaStreams = this.mediasoup.getForcedBlockedMediaStreams();

    const getLastSelectedMedia = () =>
      this.mediasoup.getRemoteMedias().find(({ isLastSelected }) => isLastSelected);

    const getSelectedMedia = () =>
      this.mediasoup.getRemoteMedias().find(remoteMedia => remoteMedia.isSelected);

    if (!forcedBlockedMediaStreams[blockedMediaType]) {
      this.mediasoup.setNewMediaBlockedStreams({ [blockedMediaType]: !allClassModeFlag });

      if (allClassModeFlag) {
        this.resumeGettingMediaThreads(null, blockedMediaType);
        return;
      }

      if (excludedPeerId) {
        this.resumeGettingCertainMediaThread(excludedPeerId, blockedMediaType);
      }

      this.stopGettingMediaThreads(excludedPeerId, blockedMediaType);
      return;
    }

    if (allClassModeFlag) {
      const lastSelectedMedia = getLastSelectedMedia();

      if (lastSelectedMedia) {
        const { peerId } = lastSelectedMedia;
        this.stopGettingCertainMediaThread(peerId, blockedMediaType);
      }

      return;
    }

    const selectedMedia = getSelectedMedia();

    if (selectedMedia) {
      const { peerId } = selectedMedia;
      this.resumeGettingCertainMediaThread(peerId, blockedMediaType);
    }
  }

  async setPreferredScalabilityLayer(peerId, scalabilityLevel, isTeacher) {
    const { roomId } = this.roomInfo;
    const remoteMedias = this.mediasoup.getAllRemoteMedias();
    let remoteMedia;
    if (isTeacher) {
      remoteMedia = remoteMedias.find(teacherMedia => teacherMedia.isTeacherPeerType === true);
    } else {
      remoteMedia = remoteMedias.find(remoteMediaItem => remoteMediaItem.peerId === peerId);
    }
    if (remoteMedia) {
      const isVideo = remoteMedia.media[mediaTypes.videoType];
      const isScreenShare = remoteMedia.media[mediaTypes.screenType];
      let consumerId;
      let layers;
      let spatialLayer;
      let temporalLayer;
      if (isVideo) {
        consumerId = remoteMedia.media[mediaTypes.videoType]?.consumer?.id;
        layers = remoteMedia.media[mediaTypes.videoType]?.scalabilityLayers;
      }
      if (isScreenShare) {
        consumerId = remoteMedia.media[mediaTypes.screenType]?.consumer?.id;
        layers = remoteMedia.media[mediaTypes.screenType]?.scalabilityLayers;
      }
      if (layers) {
        const parsedLayers = getLayersByLevel(scalabilityLevel, layers);
        spatialLayer = parsedLayers.spatialLayer;
        temporalLayer = parsedLayers.temporalLayer;
      }
      try {
        this.queue.pushTask(peerId, () => {
          this.mediasoup.setPreferredScalabilityLayer(
            peerId,
            consumerId,
            { spatialLayer, temporalLayer },
            isTeacher,
          );
          this.queue.resumeTaskExecuting(peerId);
        });
        if (consumerId) {
          await this.socket.request(this.videoConferenceActions.setLayers, {
            roomId,
            consumerId,
            spatialLayer: String(spatialLayer),
            temporalLayer: String(temporalLayer),
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  async getChatMessages(page) {
    await this.socket.request(this.chatActions.getMessagesChat, { page });
  }

  async readMessageChat(id) {
    await this.socket.request(this.chatActions.readMessageChat, {
      message: { id },
    });
  }

  async sendChatMessage(message, attachments = []) {
    await this.socket.request(this.chatActions.sendMessageChat, {
      lesson_hash: this.lessonHash,
      body: message,
      attachments,
    });
  }

  async deleteChatMessage(id) {
    await this.socket.request(this.chatActions.deleteMessageChat, {
      lesson_hash: this.lessonHash,
      message: { id },
    });
  }

  async startScreenShare() {
    try {
      await this.mediasoup.produce(mediaTypes.screenType);
    } catch (e) {
      if (!(e instanceof MediaError)) {
        toast.error(e.message);
      }
    }
  }

  async stopScreenShare() {
    const { roomId } = this.roomInfo;
    const { producerId } = this.mediasoup.mediaStore.localMedia[mediaTypes.screenType];
    await this.socket.request(this.videoConferenceActions.stopShareScreen, {
      roomId,
      producerId,
    });
    this.mediasoup.closeProducer(producerId);
  }

  async showThemeButtons(peerId) {
    if (peerId) {
      await this.socket.request(this.videoConferenceTeacherAction.showThemeButtonsTo, {
        peer_id: peerId,
      });
    } else {
      await this.socket.request(this.videoConferenceTeacherAction.showThemeButtons);
    }
  }

  async hideThemeButtons(peerId) {
    if (peerId) {
      await this.socket.request(this.videoConferenceTeacherAction.hideThemeButtonsTo, {
        peer_id: peerId,
      });
    } else {
      await this.socket.request(this.videoConferenceTeacherAction.hideThemeButtons);
    }
  }

  async firstThemeButtonReaction() {
    await this.socket.request(this.videoConferenceTeacherAction.firstThemeButtonReaction);
  }

  async secondThemeButtonReaction() {
    await this.socket.request(this.videoConferenceTeacherAction.secondThemeButtonReaction);
  }

  async studentToiletNeeded() {
    await this.socket.request(this.videoConferenceTeacherAction.toiletNeed);
  }

  async studentHandUppend() {
    await this.socket.request(this.videoConferenceTeacherAction.handUp);
  }

  async showYesNoButtons(peerId) {
    if (peerId) {
      await this.socket.request(this.videoConferenceTeacherAction.showYesNoButtonsTo, {
        peer_id: peerId,
      });
    } else {
      await this.socket.request(this.videoConferenceTeacherAction.showYesNoButtons);
    }
  }

  async yesButtonReaction() {
    await this.socket.request(this.videoConferenceTeacherAction.yesButtonReaction);
  }

  async noButtonReaction() {
    await this.socket.request(this.videoConferenceTeacherAction.noButtonReaction);
  }

  async sendEmojiNotification(emojiType, peerId) {
    const payload = { emoji_type: emojiType };
    let action = this.videoConferenceTeacherAction.emojiNotification;
    if (peerId) {
      action = this.videoConferenceTeacherAction.emojiNotificationTo;
      payload.peer_id = peerId;
    }
    await this.socket.request(action, payload);
  }

  async sendStopNotification(peerId) {
    let payload = null;
    let action = this.videoConferenceTeacherAction.stopNotification;
    if (peerId) {
      action = this.videoConferenceTeacherAction.stopNotificationTo;
      payload = { peer_id: peerId };
    }
    await this.socket.request(action, payload);
  }

  async sendAttentionNotification(type, peerId) {
    let action = this.videoConferenceTeacherAction.attentionNotification;
    const payload = { attention_type: type };
    if (peerId) {
      action = this.videoConferenceTeacherAction.attentionNotificationTo;
      payload.peer_id = peerId;
    }
    await this.socket.request(action, payload);
  }

  async sendCallNotification() {
    await this.socket.request(this.videoConferenceTeacherAction.callNotification);
  }

  async sendStartMedia(type, peerId) {
    let action = this.videoConferenceTeacherAction.startStreamByCameraTo;
    const { roomId } = this.roomInfo;

    if (type === mediaTypes.audioType) {
      action = this.videoConferenceTeacherAction.startStreamByMicrophoneTo;
    }

    return this.socket.request(action, {
      peer_id: peerId,
      room_id: roomId,
    });
  }

  async sendStopMedia(type, peerId) {
    let action = this.videoConferenceTeacherAction.stopStreamByCameraTo;
    const { roomId } = this.roomInfo;

    if (type === mediaTypes.audioType) {
      action = this.videoConferenceTeacherAction.stopStreamByMicrophoneTo;
    }

    return this.socket.request(action, {
      peer_id: peerId,
      room_id: roomId,
    });
  }

  async sendMediaCommandToStudents(type, peerIds, actionType) {
    const results = [];

    for (let index = 0; index < peerIds.length; index += 1) {
      const peerId = peerIds[index];

      try {
        if (actionType === 'start') {
          await this.sendStartMedia(type, peerId);
        } else {
          await this.sendStopMedia(type, peerId);
        }

        results.push({
          peerId,
          status: 'success',
        });
      } catch (error) {
        console.error('Lesson sendMediaCommandToStudents failed', {
          actionType,
          type,
          peerId,
          error,
        });

        results.push({
          peerId,
          status: 'error',
          error,
        });
      }

      if (index < peerIds.length - 1) {
        await delay(80);
      }
    }

    return results;
  }

  getStudentsMediaList() {
    return this.mediasoup.getRemoteMedias().filter(remoteMedia => !remoteMedia.isTeacherPeerType);
  }

  getStudentsWithActiveMedia(mediaType) {
    const students = this.getStudentsMediaList();

    return students.filter(student => {
      if (mediaType === mediaTypes.videoType) {
        return (
          !!student?.media?.isVideo &&
          !this.mediasoup.mediaStore.isCameraSoftDisabled(student.peerId)
        );
      }

      if (mediaType === mediaTypes.audioType) {
        return !!student?.media?.isAudio;
      }

      return false;
    });
  }

  getStudentsWithInactiveMedia(mediaType) {
    const students = this.getStudentsMediaList();

    return students.filter(student => {
      if (mediaType === mediaTypes.videoType) {
        return (
          !student?.media?.isVideo || this.mediasoup.mediaStore.isCameraSoftDisabled(student.peerId)
        );
      }

      if (mediaType === mediaTypes.audioType) {
        return !student?.media?.isAudio;
      }

      return false;
    });
  }

  async sendStopMediaToAll(type) {
    const studentsWithActiveMedia = this.getStudentsWithActiveMedia(type);
    const peerIds = studentsWithActiveMedia.map(({ peerId }) => peerId);

    return this.sendMediaCommandToStudents(type, peerIds, 'stop');
  }

  async sendStartMediaToAll(type) {
    const studentsWithInactiveMedia = this.getStudentsWithInactiveMedia(type);
    const peerIds = studentsWithInactiveMedia.map(({ peerId }) => peerId);

    return this.sendMediaCommandToStudents(type, peerIds, 'start');
  }

  _init() {
    const [educationStakeholder, lessonHash] = getSearchParams([
      'educationStakeholder',
      'lessonHash',
    ]);
    this.educationStakeholder =
      educationStakeholder ?? localStorage.lessonAuthorizationData?.educationStakeholder;
    this.lessonHash = lessonHash ?? localStorage.lessonAuthorizationData?.lessonHash;
    this._setRoleInLesson(this.educationStakeholder);
    this._defineStores();
    this.socket = new Socket(
      this.educationStakeholder,
      this.lessonHash,
      this.modalWindowsStore,
      this.exitFromLesson,
      this.oppositeEventNames,
    );
    this.mediasoup = new Mediasoup(this.socket.request, this.videoConferenceActions);
    this.queue = new Queue();
    this.messageAdapter = new MessageAdapter();
  }

  _defineStores() {
    this.modalWindowsStore = store.getStore('modalWindowsStore');
    this.buttonsStore = store.getStore('buttonsStore');
    this.chatStore = store.getStore('chatStore');
    this.reactionStore = store.getStore('reactionStore');
  }

  _clearData() {
    this.socket = null;
    this.mediasoup = null;
    this.modalWindowsStore = null;
    this.buttonsStore = null;
    this.reactionStore = null;
    this.roleInLesson = {
      value: '',
      isTeacher: null,
      isStudent: null,
    };
    this.lessonHash = '';
    this.educationStakeholder = '';
    this.roomInfo = null;
    this.peerInfo = null;
    this.peerRoles = new Map();
    this.isIndividualLesson = null;
    this.teacherPeerId = '';
    this.isLessonInformationExist = false;
    this.isLessonOnPause = false;
    this.messageAdapter = '';
    lesson = null;
    this.isReadyToHandleEvents = false;
    this.isRelevant = false;
  }

  _setRoleInLesson(value) {
    if (
      value !== availableLessonRoles.teacher &&
      value !== availableLessonRoles.student &&
      value !== null
    ) {
      const error = new Error(
        `Role must be one of (${availableLessonRoles.teacher} || ${availableLessonRoles.student} || null)`,
      );
      error.humanReadableMessage =
        'Роль на уроке указана неверно. Возможно, ссылка была скопирована неправильно и/или изменена';
      error.code = 403;
      throw error;
    }

    this.roleInLesson.value = value || '';
    if (value) {
      this.roleInLesson.isStudent = value === availableLessonRoles.student;
      this.roleInLesson.isTeacher = value === availableLessonRoles.teacher;
    } else {
      this.roleInLesson.isStudent = value === null;
      this.roleInLesson.isTeacher = value === null;
    }
  }

  static _formatYYYYMMDD(date) {
    const d = new Date(date);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  static _addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  static _extractLessonHashFromUrl(url) {
    try {
      const u = new URL(url);
      return u.searchParams.get('lessonHash');
    } catch (e) {
      const m = String(url).match(/lessonHash=([^&]+)/);
      return m?.[1] ?? null;
    }
  }

  async _joinLesson(isReconnected = false) {
    if (!this.isRelevant || !this.socket) {
      return;
    }

    const { data } = await this.socket.request(this.actions.joinLesson);
    if (!this.isRelevant) {
      return;
    }
    const { roomId } = data.payload.lesson.room;

    await this.socket.request(this.actions.getRoomInfo, { roomId });
    const { search, pathname } = window.location;

    const searchParams = getSearchParams(['educationStakeholder', 'lessonHash'], search);

    if (searchParams[0] !== this.educationStakeholder && searchParams[1] !== this.lessonHash) {
      const params = {
        educationStakeholder: this.educationStakeholder,
        lessonHash: this.lessonHash,
      };
      const queryString = objectToSearchParams(params);
      history.replace({ pathname, search: queryString });
    }

    if (this.isLessonOnPause) {
      history.push(navigation.lessonBreak.pathWithSearch);
    } else {
      history.push(navigation.videoConference.pathWithSearch);
      await this.startLocalMedia(true, isReconnected);
    }
    this.isReadyToHandleEvents = true;
    await this.socket.rawEvents.execute();
  }

  _removePeersInfo() {
    if (this?.peerInfo) {
      this.peerInfo = null;
    }
    this.mediasoup?.removeAllConsumers();
  }
}

export { lesson, Lesson };
